import { digitsEnToFa } from 'persian-tools2';
import { useMutation } from '@tanstack/react-query';

import { loginApi, sendLoginCode, signup } from 'modules/user/services/register-service';
import { usePatientsContext } from 'store/context/patient-context';
import axiosInstance from 'utils/axiosInstance';
import { useAuthContext } from 'store/context/auth/auth-context';
import { usersUrls } from 'constants/urls';
import { registerSteps } from '../constants/register';

const handleTokenFireBase = async (event) => {
  if (
    localStorage.getItem('token') &&
    event &&
    typeof event.data === 'string'
  ) {
    const TokenData = JSON?.parse(event?.data);
    const Data = {
      token: TokenData?.tokenFireBase,
      clientApplication: TokenData?.clientApplication,
      deviceType: TokenData?.deviceType
    };
    localStorage.setItem('fireBaseToken', TokenData?.tokenFireBase);
    await axiosInstance.post(usersUrls.notificationToken, Data);
  }
  document.removeEventListener('message', handleTokenFireBase);
  window.removeEventListener('message', handleTokenFireBase);
};

export const getTokenFireBase = () => {
  window?.ReactNativeWebView?.postMessage('tokenFireBase');
  document.addEventListener('message', handleTokenFireBase);
  window.addEventListener('message', handleTokenFireBase);
};

const useSendLoginCode = () => {
  const { handleOpenSnackbar } = usePatientsContext();
  return useMutation({
    mutationFn: sendLoginCode,
    retry: false,
    onSuccess: (res, args) => {
      const {
        setSteps,
        startTimer,
        resetTimer,
        transition,
        setShowTransition,
        setUserPhone,
        userPhone,
        phone
      } = args || {};

      if (res.status === 200) {
        const status = res.data.status;
        const uniqPhoneNumbers = userPhone?.filter(
          (item) => item.phone !== phone
        );

        if (status === 0 && res.data.activationCodeId) {
          resetTimer();
          startTimer();
          setSteps(registerSteps.login);
          if (transition) {
            setShowTransition((prev) => !prev);
          }
          setUserPhone([
            ...uniqPhoneNumbers,
            {
              futurTimeExp:
                Date.now() + res.data.activationCodeRemainingSeconds * 1000,
              activationCodeId: res.data.activationCodeId,
              activationCodeRemainingSeconds:
                res.data.activationCodeRemainingSeconds,
              phone
            }
          ]);
        } else {
          const snackbarText =
            status === 3
              ? `شماره شما بعنوان پزشک ثبت نشده است`
              : status === 2
              ? `کد ارسال شده تا ${digitsEnToFa(
                  res.data.activationCodeRemainingSeconds.toString()
                )} ثانیه دیگر فعال است`
              : '';
          handleOpenSnackbar(snackbarText, 'error');
        }
      }
    },
    onError: (error) => {
      handleOpenSnackbar('خطای ارتباط با سرور، لطفا مجدد امتحان کنید', 'error');
    }
  });
};

const useLoginDoctor = () => {
  const { handleOpenSnackbar } = usePatientsContext();
  const { login } = useAuthContext();
  return useMutation({
    mutationFn: loginApi,
    onSuccess: (res, args) => {
      const { setSteps, setShowTransition, navigateToDashboard, resetTimer } =
        args || {};
      if (res.status === 200) {
        login(res.data.token.accessToken, res.data.token.refreshToken);

        const medicalNumber = res.data.user.medicalNumber;

        if (!medicalNumber) {
          setSteps(registerSteps.signup);
          setShowTransition('login');
        } else if (medicalNumber) {
          resetTimer();
          window?.ReactNativeWebView?.postMessage('login');
          localStorage.setItem('registered', true);
          setShowTransition(false);
          navigateToDashboard();
        }
      }
    },
    onError: (error) => {
      handleOpenSnackbar(error.response.data.messages, 'error');
    }
  });
};

const useSignupDoctor = () => {
  const { handleOpenSnackbar } = usePatientsContext();
  const { login } = useAuthContext();

  return useMutation({
    mutationFn: signup,
    onSuccess: (res, args) => {
      const { navigateToDashboard, setSteps } = args || {};

      if (res.status === 200) {
        localStorage.setItem('registered', true);
        window?.ReactNativeWebView?.postMessage('login');
        login(res.data.token.accessToken, res.data.token.refreshToken);
        navigateToDashboard();
        setSteps(registerSteps.sendloginCode);
      }
    },
    onError: (error) => {
      handleOpenSnackbar(error.response.data.messages, 'error');
    }
  });
};

export { useSendLoginCode, useLoginDoctor, useSignupDoctor };
